import React, { Component } from 'react';

// Images
import bg7 from '../../images/background/bg7.jpg';

import { withTranslation } from 'react-i18next';

import RoboticsInternationalFinalPhotos from "../../images/achievements/RoboticsInternationalFinal_Day1_1.jpg"
import RoboticsInternationalFinalVideos from "../../images/achievements/RoboticsInternationalFinal_Day1_15.jpg"

const images = [
	{
		thumb: RoboticsInternationalFinalPhotos,
		url: "/photos"
	},
	{
		thumb: RoboticsInternationalFinalVideos,
		url: "/videos"
	},
];

class Testimonial2 extends Component {
	componentDidMount() {

	}
	render() {
		const { t } = this.props;

		return (
			<>
				<div className="section-area section-sp2" style={{ backgroundImage: "url(" + bg7 + ")", backgroundSize: "cover", backgroundPosition: "center" }}>
					<div className="row">
						<div className="col-md-12 heading-bx style1 text-center">
							<h2 className="title-head">{t('Testimonial2_Title')}</h2>
						</div>
					</div>
					<div className="row justify-content-center">
						{images.map((item, index) => (
							<div className="col-md-3 heading-bx style1 text-center" key={index}>
								<a href={item.url}>
									<img alt="" src={item.thumb} />
								</a>
							</div>
						))}
					</div>
				</div>
			</>
		);
	}
}

export default Testimonial2 = withTranslation()(Testimonial2);